import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { IProaForm } from "@interfaces/screens/proa-form.interface";
import { ISPFEService, SPFEService } from "@services/proyecta/spfe.service";
import { ProaService, IProaService } from "@services/proyecta/proa-form.service";
import { Dictionary, Utilities, queryString, Enums } from "@utils";
import { ILang } from "@models/*";

export class FormProaPresenter extends BasePresenter<IProaForm> {
  public currentLabels: Dictionary<string, string>;
  public currentBudgetDetails: any;
  public formMasters: any;
  public currentBudget: any;
  public progress: number;
  public pendingLoad: number;
  public counter: number; 
  public subProjectsInfo: any;
  public projectsGrouped: any;
  public currentLang: ILang;
  protected proaService: IProaService;
  protected _feService: ISPFEService;

  constructor(view: IProaForm) { 
    super(view);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    this.currentBudget = useSelector(this.context.proaStore.selectCurrentBudget);
    this.subProjectsInfo = useSelector(this.context.proaStore.selectSubProjectsInfo);
    this.projectsGrouped = useSelector(this.context.proaStore.selectProjectsGrouped);
    this.currentBudgetDetails = useSelector(this.context.proaStore.selectCurrentBudgetDetails);
    this.formMasters = useSelector(this.context.proaStore.selectFormMasters);
    this.progress = useSelector(this.context.sessionStore.selectProgress);
    this.pendingLoad = useSelector(this.context.sessionStore.selectPendingLoad);
    this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
    this.counter = 0;
    this.proaService = new ProaService();
    this._feService = new SPFEService();
  }

  //#region private methods
  private getBudgetId() {
    const query = queryString.parseUrl(window.location.href.replace("#", "")).query as any;
    return query.Id;
  }

  public unSetLoading() {
    this.dispatcherProgress(90)
    setTimeout(() => {
      this.dispatcherUnsetSetLoading();
    }, 1000);
  }

  //#region Public methods
  public async initializeForm() {
    const budgetId = this.getBudgetId();

    this.dispatcherProgress(30)

    if (!Utilities.isNullEmptyObject(budgetId)) {
      this.dispatcher(this.context.proaStore.getAllProaSummary());
      this.dispatcher(this.context.proaStore.getAllFormMasters());
      this.dispatcher(this.context.proaStore.getSubProjectsInfo(budgetId));
      this.dispatcher(this.context.proaStore.getProjectsGrouped(budgetId));
      this.dispatcher(this.context.proaStore.getBudget(budgetId));
      this.dispatcher(this.context.proaStore.getBudgetDetails(budgetId));

      this.dispatcherProgress(60)

      const [FFRR, FFEE, appMasters, dataColumns] = await Promise.all([
        this.proaService.getDefinitionColumnsProaFR(this.currentLang.id), 
        this._feService.getDataColumns(this.currentLang.id),
        this.proaService.getAllFormMasters(this.currentLang.label),
        this.proaService.getProaBasicDataColumnDefinition(this.currentLang.id)
      ])  as any;

      this.dispatcherProgress(80)
      this.view.state.setColumns({FFRR, FFEE})
      this.view.state.setSummaryData({appMasters, dataColumns})
    }
  }

  

  public getFormFeTabs() {
    let tabsArray: Array<any> = this.selectTabs(this.currentBudgetDetails);

    let tabsEmpty: any[] = [];
    let tabsShow: any[] = [];
    tabsArray = tabsArray.map((tab: any) => {
      let showTab = true;
      let Empty = true;
      let _tab: any = {
        title: tab.PPresCodSubvencion.Title,
        id: tab.PPresCodSubvencion.Id,
        grantCode: tab.PPresCodSubvencion.OCTAVIACodigoSubvencion,
      };
      this.projectsGrouped.forEach((pr: any) => { 
        if(pr?.SubProyectosAgrupadosId?.includes(tab.PPresCodSubvencion.Id)) {showTab = false;}
        if(pr.PPresCodSubvencionId === tab.PPresCodSubvencion.Id){ showTab = true; _tab.grouped = true;}
      })
      
      if(Empty) tabsEmpty.push(_tab.id)
      if(showTab) tabsShow.push(_tab)
      return _tab
    });

    return {tabsShow, tabsEmpty, tabsArray}
  }
  
  private selectTabs(data: any) {
    const tabsName: Array<string> = [];
    const result: Array<any> = [];

    data?.forEach((tab: any) => {
      const name = tab?.PPresCodSubvencion?.OCTAVIACodigoSubvencion;
      const indName = name?.substring(0, 1);
      if (!Utilities.isNullEmptyObject(indName)) {
        let addResult = false;
        switch (indName) {
          case Enums.Prefix.Contributions.toString():
            addResult = false;
            break;
          case Enums.Prefix.Donations.toString():
            addResult = tabsName.indexOf(name) === -1;
            break;
          default:
            addResult = Number.isInteger(Number.parseInt(indName)) && tabsName.indexOf(name) === -1;
            break;
        }
        if (addResult) {
          tabsName.push(name);
          result.push(tab);
        }
      }
    });
    return result;
  }
  //#endregion
}
